<wlm-popup-wrapper [titleKey]="T_SCOPE + '.title'" [showCloseButton]="true" (popupClose)="cancel()">
  <ng-container popup-content>
    <wlm-trend-chart
      *ngIf="attributesChartConfiguration"
      [size]="calculatedSize$ | async"
      [chartSettings]="chartSettings"
      [disableInnerLoading]="false"
    ></wlm-trend-chart>
  </ng-container>
</wlm-popup-wrapper>
